module.exports = __webpack_public_path__ + "img/usa.29be3732.svg";